<template>
    <div class="favorites-container">
        <div class="hero-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 mx-auto text-center">
                        <h1>{{ labels.title }}</h1>
                    </div>
                </div>
            </div>
            <ef2-brand-shape></ef2-brand-shape>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="favorites-list container section-spacing-margin">
                        <div v-if="loading" class="loading">
                            {{ labels.loading }}
                        </div>

                        <div v-else>
                            <div v-if="categories.length > 1" class="favorites-filter">
                                <button
                                    class="filter-button"
                                    :class="{ active: activeCategory === 'all' }"
                                    @click="activeCategory = 'all'"
                                >
                                    Alles
                                </button>
                                <button
                                    v-for="category in categories"
                                    :key="category"
                                    class="filter-button"
                                    :class="{ active: activeCategory === category }"
                                    @click="activeCategory = category"
                                >
                                    {{ category }}
                                </button>
                            </div>

                            <div v-if="Object.keys(groupedTeasers).length > 0" class="favorites-groups">
                                <div v-for="(groupTeasers, groupName) in groupedTeasers" :key="groupName"
                                     class="category-group">
                                    <h3>{{ groupName }}</h3>
                                    <div class="view-content">
                                        <div v-for="teaser in groupTeasers" :key="teaser.id"
                                             class="layout-teaser layout-default-teaser">
                                            <div class="inner">
                                                <ef2-favorite-button :entity-id="teaser.id"></ef2-favorite-button>

                                                <a :href="teaser.link" class="image-wrapper">
                                                    <img v-if="teaser.image" :src="teaser.image" :alt="teaser.title"
                                                         loading="lazy">

                                                    <div v-if="teaser.bundle === 'evenement'" class="event-label">
                                                        Evenement
                                                    </div>
                                                </a>

                                                <div class="content-wrapper">
                                                    <div class="field-content">

                                                        <div v-if="teaser.category" class="category">
                                                            {{ teaser.category }}
                                                        </div>
                                                        <h4 class="views-field-title">
                                                            <a :href="teaser.link">{{ teaser.title }}</a>
                                                        </h4>
                                                        <div v-if="teaser.bundle === 'evenement' && teaser.date_input === '1'" class="event-date">
                                                            <span v-if="teaser.date_start && teaser.date_end && teaser.date_start !== teaser.date_end">
                                                                {{ formatDate(teaser.date_start) }} - {{ formatDate(teaser.date_end) }}
                                                            </span>
                                                            <span v-else-if="teaser.date_start">
                                                                {{ formatDate(teaser.date_start) }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="no-favorites">
                                {{ labels.no_favorites }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FavoritesList",

    props: {
        endpoint: {
            type: String,
            required: true
        },
        labels: {
            type: Object,
            default: () => ({
                title: 'Mijn favorieten',
                no_favorites: 'Je hebt nog geen favorieten opgeslagen.',
                loading: 'Laden...'
            })
        }
    },

    data() {
        return {
            teasers: [],
            loading: false,
            activeCategory: 'all'
        }
    },

    computed: {
        categories() {
            const cats = this.teasers
                .map(t => t.categoryGroup)
                .filter(c => c && c !== '');
            return [...new Set(cats)].sort();
        },
        groupedTeasers() {
            const groups = {};

            const filtered = this.activeCategory === 'all'
                ? this.teasers
                : this.teasers.filter(t => t.categoryGroup === this.activeCategory);

            filtered.forEach(teaser => {
                const group = teaser.categoryGroup || 'Overig';
                if (!groups[group]) {
                    groups[group] = [];
                }
                groups[group].push(teaser);
            });

            return groups;
        }
    },

    mounted() {
        this.fetchTeasers();

        // Listen for changes in favorites
        window.vueBase.eventBus.$on('favorites-updated', (favorites) => {
            this.fetchTeasers(favorites);
        });
    },

    methods: {
        fetchTeasers(providedFavorites = null) {
            const favorites = providedFavorites || JSON.parse(localStorage.getItem('drupal_favorites') || '[]');

            if (favorites.length === 0) {
                this.teasers = [];
                return;
            }

            this.loading = true;
            axios.post(this.endpoint, {
                ids: favorites
            })
                .then(response => {
                    this.teasers = response.data.teasers;
                    this.loading = false;
                })
                .catch(error => {
                    console.error("Error fetching favorite teasers:", error);
                    this.loading = false;
                });
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('nl-NL', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        }
    }
}
</script>

